module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_arrow_nav-431b16a302535de3a0a8a2d5afd3da0d.svg";